const API = process.env.REACT_APP_BACKEND_URL;

export async function fetchAdminPrintInterest(limit) {
  const url = new URL(`${API}/api/admin/print-interest`);
  if (limit) url.searchParams.set("limit", limit);
  const res = await fetch(url.toString(), { credentials: "include" });
  if (!res.ok) {
    const data = await res.json().catch(() => ({}));
    throw new Error(data.detail || "Could not load print interest data");
  }
  return res.json();
}

export function adminPrintInterestCsvUrl() {
  return `${API}/api/admin/print-interest/export.csv`;
}
